import type React from 'react';

import * as styles from './styles';

import Icon from '@cobliteam/ui/icons';

import { ControlButton } from '../ControlButton/ControlButton';

export interface FullscreenControlProps {
  active: boolean;
  className?: string;
  onToggle: (active: boolean) => void;
}

export const FullscreenControl: React.FC<FullscreenControlProps> = ({ active, className, onToggle }) => {
  const handleToggle = () => onToggle(!active);

  return (
    <div className={`leaflet-control mt-2 ${styles.fullscreenControl} ${className || ''}`}>
      <ControlButton Icon={<Icon name={active ? 'minimize' : 'maximize'} />} onClick={handleToggle} />
    </div>
  );
};
